module.exports = __webpack_public_path__ + "img/qdj-bg.6f021c3c.png";